// Budget endpoints with a per-month cache.

import { apiFetch } from './client';
import type { Budget, CategoryLine, IncomeSchedule } from './types';

const budgetCache = new Map<string, Budget | null>();

// Get budget for a month
export async function getBudgetForMonth(yearMonth: string): Promise<Budget | null> {
	if (budgetCache.has(yearMonth)) {
		return budgetCache.get(yearMonth) ?? null;
	}
	try {
		const budget = await apiFetch<Budget | null>(`/budgets/${yearMonth}`);
		budgetCache.set(yearMonth, budget ?? null);
		return budget;
	} catch {
		return null;
	}
}

// Save budget for a month
export async function saveBudget(
	yearMonth: string,
	budget: {
		plannedIncome?: number;
		categoryBudgets?: Record<string, number>;
		categoryLines?: Record<string, CategoryLine[]>;
		incomeSchedules?: IncomeSchedule[];
	}
): Promise<void> {
	await apiFetch(`/budgets/${yearMonth}`, {
		method: 'PUT',
		body: JSON.stringify(budget),
	});
	budgetCache.set(yearMonth, {
		pk: `BUDGET#${yearMonth}`,
		sk: 'PLAN',
		plannedIncome: budget.plannedIncome ?? 0,
		categoryBudgets: budget.categoryBudgets ?? {},
		categoryLines: budget.categoryLines,
		incomeSchedules: budget.incomeSchedules ?? [],
	});
}
